import { render, staticRenderFns } from "./NotificacaoInput.vue?vue&type=template&id=6375d2af&"
import script from "./NotificacaoInput.vue?vue&type=script&lang=js&"
export * from "./NotificacaoInput.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports